// extracted by mini-css-extract-plugin
module.exports = {"vertical":"FocusGroup_vertical__3WofJ","horizontal":"FocusGroup_horizontal__ysM_4"};